module.exports = __webpack_public_path__ + "img/puberty-decal-24.e87608b6.png";